import type { LDContext } from "launchdarkly-react-client-sdk";

/**
 * Builds the LaunchDarkly `user` context. `subdomain` is a custom attribute
 * used for host-based targeting (e.g. `smartly` from `smartly.aiapp.example.com`).
 * Empty string when the host has no subdomain so the attribute is always present
 * in the LD debugger and targeting rules can match "is empty".
 */
export function buildLdUserContext(input: {
  userId: string;
  name?: string;
  email?: string;
  subdomain: string | null;
}): LDContext {
  return {
    kind: "user",
    key: input.userId,
    name: input.name,
    email: input.email,
    subdomain: input.subdomain ?? "",
  };
}
